module.exports = __webpack_public_path__ + "img/digital-membership-pass@2x.499d0af3.png";